import jsBridgeApi from '../lib/JSBridge';

// 以下是无返回请求

/**
 * 通知native token失效（重定向到登录页）
 */
export function tokenInvalid() {
  try {
    jsBridgeApi.send('tokenInvalid');
  } catch (error) {
    console.log(error);
  }
}

/**
 * 返回列表
 */
export function back2SummaryList() {
  try {
    jsBridgeApi.send('back2SummaryList');
  } catch (error) {
    console.log(error);
  }
}

/**
 * 打开分享弹窗
 */
export function openShare() {
  try {
    jsBridgeApi.send('openShare');
  } catch (error) {
    console.log(error);
  }
}
